import React, { Component } from 'react';

class GalleryContainer extends Component {
    render() {
        return (
            <div>
                Gallery
            </div>
        );
    }
}

export default GalleryContainer;